import { dramas } from "@/mocks/dramas";
import DramaCard from "@/pages/home/components/DramaCard";
import SectionHeading from "@/pages/home/components/SectionHeading";
import Reveal from "@/components/feature/Reveal";

export default function NowAiring() {
  const airing = dramas.filter((d) => d.status === "热播中");

  return (
    <section id="airing" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
          <SectionHeading
            eyebrow="Now Airing"
            title="正在热播的韩剧"
            desc="以下剧集当前都在播出档期内，一集一集陆续更新。卡片上标注了最新进度与站内热度，可以按更新节奏安排追剧顺序。"
          />
          <a
            href="#latest"
            className="inline-flex items-center gap-1.5 text-sm font-label text-primary-700 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap self-start lg:self-auto"
          >
            查看全部更新动态
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </div>

        <div className="mt-8 md:mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {airing.map((drama, index) => (
            <Reveal key={drama.id} delay={(index % 3) * 80}>
              <DramaCard drama={drama} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}